export const expirationDaysOptions = [
  { label: 'Sem Expiração', value: 0 },
  { label: '1 semana', value: 7 },
  { label: '1 mês', value: 30 },
  { label: '3 meses', value: 90 },
  { label: '6 meses', value: 180 },
  { label: '1 ano', value: 365 }
];

export const noAllowedDomainsExpirationDaysOptions = [
  { label: 'Sem Expiração', value: 0 },
  { label: '1 semana', value: 7 },
  { label: '1 mês', value: 30 },
  { label: '3 meses', value: 90 }
];